import { useNavigate } from 'react-router-dom'

import { PerformanceFeedbackEntriesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { EmptyState } from 'modules/performance_feedbacks/components/EmptyState'
import { FeedbackEntries } from 'modules/performance_feedbacks/components/FeedbackEntries'

const GivenFeedback = () => {
  const { access } = useCurrentSession()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { data } = useQuery(PerformanceFeedbackEntriesDocument, {
    variables: {
      authorId: access.id,
    },
  })
  const feedbackEntries = data?.feedbacks.feedbackEntriesConnection.nodes

  return (
    <ResponsivePage.NestedBody>
      {!feedbackEntries?.length && (
        <EmptyState
          title={i18n.t('performance_feedbacks.empty_state.given_feedback.title')}
          description={i18n.t('performance_feedbacks.empty_state.given_feedback.description')}
          buttonText={i18n.t('performance_feedbacks.pages.give_feedback.title')}
          onClick={() => navigate(navigation.performanceFeedbacks.giveFeedback.fullPath())}
        />
      )}
      <FeedbackEntries entries={feedbackEntries || []} />
    </ResponsivePage.NestedBody>
  )
}

export default GivenFeedback
